import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "creditBadge"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon");
  const _component_w_html_tool_tip = _resolveComponent("w-html-tool-tip");
  return _openBlock(), _createBlock(_component_w_html_tool_tip, {
    placement: _ctx.placement,
    label: _ctx.$t('thumbnailGenerator.costsCredits')
  }, {
    default: _withCtx(() => [_createElementVNode("span", _hoisted_1, [_createVNode(_component_icon, {
      icon: "star-four-points-circle-outline"
    })])]),
    _: 1
  }, 8, ["placement", "label"]);
}